import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const ContactUs = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    const handleMediaQueryChange = (e) => setIsMobile(e.matches);

    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => mediaQuery.removeEventListener("change", handleMediaQueryChange);
  }, []);

  const handleSubmit = () => {
    setTimeout(() => setIsSubmitted(true), 800); // short delay to show feedback
  };

  return (
    <div className="w-full px-4 py-16 bg-[#d2e5e4] flex justify-center items-center">
      <motion.div
        className="flex flex-col md:flex-row w-full max-w-6xl bg-white shadow-lg rounded-xl overflow-hidden"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        {/* Contact Info */}
        <div className="md:w-1/2 p-8 bg-[#3d302c] text-white">
          <h2 className="text-3xl font-bold mb-6 ">Let’s Talk :</h2>

          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-2">Address</h4>
            <ul className="space-y-1">
                 <li>
                <span className="font-bold text-yellow-400">U.S.A:</span> 1 oxford valley ,Suite  314,  Langhorne, Pennsylvania, 19067 USA
              </li>
              <li>
                <span className="font-bold text-yellow-400">India:</span>  Silicon Valley, Madhapur, Hyderabad, Telangana 500081, INDIA
              </li>
           
            </ul>
          </div>

          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-2">Contact</h4>
            <ul className="space-y-1">
              <li>+91 9888268456</li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-semibold mb-2">Email</h4>
            <p className="text-yellow-300">sales@medimind.in</p>
          </div>
        </div>

        {/* Contact Form */}
        <div className="md:w-1/2 p-8">
          <h3 className="text-2xl font-bold mb-2">
            We're here to <span className="text-[#3d302c]">Help!</span>
          </h3>
          <p className="text-gray-600 mb-6">
            Whether you have a question, feedback, or need support, feel free to
            reach out to us. Our team is dedicated to providing quick and helpful
            responses.
          </p>

          {isSubmitted ? (
            <div className="text-center space-y-2 py-10">
              <h4 className="text-xl font-semibold text-green-600">
                Thank you for contacting us!
              </h4>
              <p className="text-gray-700">We’ll get back to you soon.</p>
            </div>
          ) : (
            <form
              action="https://formspree.io/f/xzzvengg"
              method="POST"
              onSubmit={handleSubmit}
              className="space-y-4"
            >
              <input
                type="text"
                name="name"
                placeholder="Your Full Name*"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3d302c]"
                required
              />
              <div className="flex flex-col md:flex-row gap-4">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email*"
                  className="flex-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3d302c]"
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone Number*"
                  className="flex-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3d302c]"
                  required
                />
              </div>
              <textarea
                name="message"
                placeholder="Write Message*"
                rows="4"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3d302c]"
                required
              ></textarea>
              <button
                type="submit"
                className="w-full py-3 px-6 bg-[#3d302c] text-white font-semibold rounded-lg hover:bg-[#2e221e] transition duration-300"
              >
                Submit
              </button>
            </form>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default ContactUs;
